const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getSandboxQueryOptions } from '@/lib/queries/loop-planner/useGetSandbox';
import { getTimelineItemsDataSetQueryOptions } from '@/lib/queries/loop-planner/useGetTimelineItemsDataSet';
import { isHttpError } from '@/lib/utils/common/isHttpError';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/sandbox/timeline/')({
  loader: async ({
    params: {
      loopId,
      org
    },
    context: {
      queryClient
    }
  }) => {
    try {
      const sandbox = await queryClient.ensureQueryData(getSandboxQueryOptions({
        loopId: Number(loopId)
      }));
      await queryClient.ensureQueryData(getTimelineItemsDataSetQueryOptions({
        loopId: Number(loopId),
        scenarioId: sandbox.id
      }));
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner',
          params: {
            org,
            loopId
          }
        });
      }
      throw error;
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner
});